import React from 'react';
import type PlanSettingsScenariosType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/scenarios/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - scenarios page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsScenarios = lazyForPaint<typeof PlanSettingsScenariosType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-scenarios", jiraSpaEntry: "async-plan-settings-scenarios" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/scenarios'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsScenarios = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSettingsScenarios} pageId="plan-settings-scenarios" shouldShowSpinner />
);

export default AsyncPlanSettingsScenarios;
